/**
 * 枚举类型
 */

/**
 * 左右
 */
export enum LeftRightEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

/**
 * 方法类型
 */
export enum MethodEnum {
  ADD,
  DELETE,
  EDIT,
}

/**
 * 返回code状态
 */
export enum CodeStateEnum {
  SUCCESS = '0',
}

export const enum DEVICE_WIDTH_MAP {
  H5 = 375,
  PAD = 768,
  PC = 1025,
}

/**
 * 会员卡类型
 */
export enum MemberCardTypeEnum {
  ORIGINAL_PRICE = '-1',
}

/**
 * 功能类型
 */
export enum FunctionTypeEnum {
  /** 确定 */
  CONFIRM = 'confirm',
  /** 取消 */
  CANCEL = 'cancel',
}

/**
 * 卡类型
 */
export enum PrivilegeTypeEnum {
  // 活动卡
  ACTIVITY_DISCOUNT = 'ACTIVITY_DISCOUNT',
  // 会员卡折扣
  MEMBER_CARD_DISCOUNT = 'MEMBER_CARD_DISCOUNT',
  // 原价
  ORIGINAL_PRICE = 'ORIGINAL_PRICE',
}

export enum EmailPhoneEnum {
  EMAIL = 'email',
  PHONE = 'phone',
}


export enum LoginStatus {
  LOGIN,
  NOLOGIN,
  GUEST
}